import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ModalService } from "src/app/modules/modal/services/modal.service";
import { FormBuilder, FormGroup, FormControl, FormArray } from "@angular/forms";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app";
import { selectAuthenticatedUser } from "src/app/store/selectors";
import * as moment from "moment";
import { ApiService } from "src/app/services/api/api.service";
import { CookieService } from "src/app/services/cookie.service";
import { cookieNames } from "src/app/services/cookie.service";

@Component({
  selector: "app-fill-balance",
  templateUrl: "./fill-balance.component.html",
  styleUrls: ["./fill-balance.component.scss"],
})
export class FillBalanceComponent implements OnInit, OnDestroy {
  private balanceForm: FormGroup;

  private modalSubjectSubscription: Subscription;
  private modalSubject = new BehaviorSubject(1);
  private modalStep;

  private authenticatedUserSubscription: Subscription;
  public authenticatedUser$: Observable<any>;

  private paymentSubscription: Subscription;

  private userInformation;

  constructor(
    private _store: Store<IAppState>,
    private modalService: ModalService,
    private formBuidler: FormBuilder,
    private apiService: ApiService,
    private cookieService: CookieService,
  ) {}

  ngOnInit() {
    this.balanceForm = this.formBuidler.group({
      price: new FormControl(null),
      phone_code: new FormControl(null),
      full_name: new FormControl(null),
      legal_title: new FormControl(null),
      personal_number: new FormControl(null),
      id_number: new FormControl(null),
      auction_number: new FormControl(null),
      card: new FormControl(null),
      save_card: new FormArray([]),
    });

    this.modalSubjectSubscription = this.modalSubject.subscribe(
      (item: number) => {
        this.modalStep = item;
      },
    );

    this.authenticatedUser$ = this._store.pipe(select(selectAuthenticatedUser));

    this.authenticatedUserSubscription = this.authenticatedUser$.subscribe(
      (res) => {
        this.userInformation = res;
        if (this.isUserPhysical) {
          this.balanceForm
            .get("full_name")
            .setValue(res.me.first_name + " " + res.me.last_name);
          this.balanceForm.get("full_name").disable();
          this.balanceForm
            .get("personal_number")
            .setValue(res.me.personal_number);
          this.balanceForm.get("personal_number").disable();
        }
        if (this.isUserLegal) {
          this.balanceForm.get("legal_title").setValue(res.me.legal_title);
          this.balanceForm.get("legal_title").disable();
          this.balanceForm.get("id_number").setValue(res.me.id_number);
          this.balanceForm.get("id_number").disable();
        }
      },
    );
  }

  openFirstStep() {
    this.modalSubject.next(1);
  }

  openCustomStep(step) {
    this.modalSubject.next(step);
  }

  closeModal() {
    this.modalService.closePopup();
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById("print-section").innerHTML;
    // popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto'); in case popup is needed
    popupWin = window.open("", "_blank");
    popupWin.document.open();
    popupWin.document.write(`
    <html>
      <head>
        <style>
          img {width:150px; margin-left: 30px; margin-top: 30px;}
          p,label { margin: 0; padding: 0;font-family: FiraGO-bold; margin-bottom: 0.5rem}
          table { width: 100%; border-collapse: collapse;}
          td:first-of-type {min-height: 200px;height: 100%; padding: 1rem 0.5rem;}
          td, th {padding: 1em 0.5em 1em 0.5em}
          table,tbody,th,td {border: 1px solid black;}
          th:not(:first-child ), td:not(:first-child ){ text-align: center !important;}
          th:first-of-type {padding-left: 0.5rem}
          th, td{text-align: left;}
          .print {margin: 10px;}
          .print-body {margin-top: 30px; }
          .print-content {width: 90%; margin-top: 50px;margin-left: auto;margin-right: auto;}
          .info { margin-top: 30px;}
          .info-label {-webkit-text-stroke: 0.015em rgb(0,0,0);}
          .border-right-none { border-right: none;}
          .border-left-none {border-left: none;}
          text-align-center {text-align: center;}
          .print-footer {position: fixed;display: flex;justify-content: center;align-items: center;bottom: 0;margin-bottom: 30px;background: #0045ff;color: #fff;width: 100%;padding: 20px;-webkit-print-color-adjust: exact;}

          @page 
          {
            size:  auto;   /* auto is the initial value */
            margin: 0mm;  /* this affects the margin in the printer settings */
          }
          body
          {
            margin: 0; /* margin you want for the content */
          }
        </style>
      </head>
      <body onload="window.print();">
        ${printContents}
      </body>
    </html>`);
    popupWin.document.close();
  }

  onBalanceFill() {
    const Params = {
      amount: this.getFillPrice,
      redirect_success: `${location.origin}/payment/success`,
      redirect_fail: `${location.origin}/payment/failed`,
    };

    this.paymentSubscription = this.apiService
      .post(`payments/init`, Params)
      .subscribe((response) => {
        const {
          params: { trans_id = {} },
          submit_url = {},
        } = response.data.result || {};

        let input = document.createElement("input");
        input.setAttribute("value", trans_id);
        input.setAttribute("name", "trans_id");

        let paymentForm = document.createElement("form");
        paymentForm.action = submit_url;
        paymentForm.method = "POST";

        document.body.appendChild(paymentForm);
        paymentForm.appendChild(input);
        paymentForm.submit();

        this.cookieService.setCookie(cookieNames.paymentResult, "true");
      });
  }

  get form() {
    return this.balanceForm;
  }

  get getModalStep() {
    return this.modalStep;
  }

  get getModalFirstStep() {
    return this.modalStep === 1;
  }

  get payWithCard() {
    return this.modalStep === 2;
  }

  get payWithInvoice() {
    return this.modalStep === 3;
  }

  get currentDate() {
    return moment(new Date()).locale("ka").format(`DD/MM/YYYY`);
  }

  get getUserInformation() {
    return this.userInformation.me;
  }

  get getFullName() {
    return this.isUserPhysical
      ? this.getUserInformation.first_name +
          " " +
          this.getUserInformation.last_name
      : this.getUserInformation.legal_title;
  }

  get getFillPrice() {
    return this.form.controls.price.value;
  }

  get isUserPhysical() {
    return this.getUserInformation.roles.includes("physical");
  }

  get isUserLegal() {
    return this.getUserInformation.roles.includes("legal");
  }

  ngOnDestroy() {
    if (this.modalSubjectSubscription)
      this.modalSubjectSubscription.unsubscribe();
    if (this.authenticatedUserSubscription)
      this.authenticatedUserSubscription.unsubscribe();
    if (this.paymentSubscription) this.paymentSubscription.unsubscribe();
  }
}
